import { RateType } from 'shared-types/Rate';

import {
  GET_RATES_REQUEST,
  GET_RATES_SUCCESS,
  GET_RATES_FAILURE,
  GET_SINGLE_RATE_REQUEST,
  GET_SINGLE_RATE_SUCCESS,
  GET_SINGLE_RATE_FAILURE,
  GET_RATE_ROOMS_SUCCESS,
  GET_RATE_ROOMS_FAILURE,
  GET_RATE_ROOMS_REQUEST,
} from './actions';

export type RateStateType = {
  isListFetching: boolean;
  list: {
    data: Omit<RateType, 'rooms'>[];
  };
  isRateFetching: boolean;
  singleRate: RateType | null;
  errorReason: { text: string; value: string | number } | null;
};

export const initialState: RateStateType = {
  isListFetching: false,
  list: {
    data: [],
  },
  isRateFetching: false,
  singleRate: null,
  errorReason: null,
};

const handleErrorReason = (payload) => {
  const text = payload.response?.data?.title;
  const value = payload.response?.data?.qualifier;
  return text || value ? { text, value } : null;
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case GET_RATES_REQUEST:
      return {
        ...state,
        isListFetching: true,
      };
    case GET_RATES_SUCCESS:
      return {
        ...state,
        isListFetching: false,
        list: payload,
        errorReason: null,
      };
    case GET_RATES_FAILURE:
      return {
        ...state,
        isListFetching: false,
        list: initialState.list,
        errorReason: handleErrorReason(payload),
      };
    case GET_SINGLE_RATE_REQUEST:
      return {
        ...state,
        isRateFetching: true,
      };
    case GET_SINGLE_RATE_SUCCESS:
      return {
        ...state,
        isRateFetching: false,
        singleRate: {
          ...payload,
          extras: state.singleRate?.extras,
        },
      };
    case GET_SINGLE_RATE_FAILURE:
      return {
        ...state,
        singleRate: initialState.singleRate,
        isRateFetching: false,
      };
    case GET_RATE_ROOMS_REQUEST:
      return {
        ...state,
        isRateFetching: true,
      };
    case GET_RATE_ROOMS_SUCCESS:
      return {
        ...state,
        isRateFetching: false,
        singleRate: {
          ...state.singleRate,
          rooms: payload,
        },
        errorReason: null,
      };
    case GET_RATE_ROOMS_FAILURE:
      return {
        ...state,
        isRateFetching: false,
        singleRate: {
          ...state.singleRate,
          rates: [],
        },
        errorReason: handleErrorReason(payload),
      };
    default:
      return state;
  }
};

export default reducer;
